
import ApiService from '@/services/configs/api.service'

const SouscriptionService = {
   
    create(params) {
      return ApiService.post("register", params);
    },
    pay(slug){
      return ApiService.get(`transactions/${slug}/payer`)

    }

  };

  export default SouscriptionService;
  